import { render, staticRenderFns } from "./FormTagsRemoval.vue?vue&type=template&id=14f83105&"
import script from "./FormTagsRemoval.vue?vue&type=script&lang=js&"
export * from "./FormTagsRemoval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports